import React,{Component} from 'react';

import './LoadMore.less';

const LoadMore = ({action,type}) => <div className={`more-button ${type}`} onClick={action} />


export default LoadMore



// WEBPACK FOOTER //
// ./src/components/LoadMore.js